import { useDropzone } from "react-dropzone";

const FileDropzone = ({ onDrop }: { onDrop: (f: any) => Promise<void> }) => {
  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      className="border border-dashed border-gray-700 text-center p-8"
    >
      <input {...getInputProps()} />
      <p>{`Drag 'n' drop a file here, or click to select.`}</p>
    </div>
  );
};

export default FileDropzone;
